module.exports = __webpack_public_path__ + "static/media/carnival.66d309d9.png";